import { NetworkValue, StableCoinValue } from '@/utils/currencies'
import {
  TransactionType,
  TransactionValue,
} from '@/reducers/transactionReducer'

type TransactionUrlState = {
  anchorSide: 'left' | 'right'
  currentSearch: string
  fiatAmount: number
  network: NetworkValue
  stableCoin: StableCoinValue
  stableCoinAmount: number
  transactionType: TransactionValue
}

export const createTransactionSearchParams = ({
  anchorSide,
  currentSearch,
  fiatAmount,
  network,
  stableCoin,
  stableCoinAmount,
  transactionType,
}: TransactionUrlState) => {
  const params = new URLSearchParams(currentSearch)
  const stableCoinLabel = `${stableCoin}-${network}`
  const isBuy = transactionType === TransactionType.BUY

  params.set('leftSideLabel', isBuy ? 'CAD' : stableCoinLabel)
  params.set('rightSideLabel', isBuy ? stableCoinLabel : 'CAD')

  if (anchorSide === 'left') {
    params.set('leftSideValue', String(isBuy ? fiatAmount : stableCoinAmount))
    params.delete('rightSideValue')
  } else {
    params.delete('leftSideValue')
    params.set('rightSideValue', String(isBuy ? stableCoinAmount : fiatAmount))
  }

  return params
}
